import type { ProductFeatureGroup } from "@itaas/pep-contracts";
import type { PepLocale } from "../../i18n/types";

interface ProductCapabilitiesGridProps {
  locale: PepLocale;
  groups: ProductFeatureGroup[];
}

const GROUP_ICONS = ["📦", "🗓️", "💼", "📈", "🌐", "⚙️"];

export function ProductCapabilitiesGrid({ locale, groups }: ProductCapabilitiesGridProps) {
  if (!groups.length) return null;

  return (
    <section className="pep-pd-section pep-pd-section--muted" aria-labelledby="pep-pd-modules-title">
      <div className="container">
        <h2 id="pep-pd-modules-title" className="pep-pd-section__title">
          {locale === "en" ? "Key modules" : "Modules clés"}
        </h2>
        <div className="pep-pd-modules">
          {groups.map((group, idx) => {
            const title =
              locale === "en" && group.titleEn ? group.titleEn : group.titleFr;
            const features = group.features.slice(0, 4);
            return (
              <article key={title} className="pep-pd-module-card">
                <span className="pep-pd-module-card__icon" aria-hidden>
                  {GROUP_ICONS[idx % GROUP_ICONS.length]}
                </span>
                <h3 className="pep-pd-module-card__title">{title}</h3>
                <ul className="pep-pd-module-card__list">
                  {features.map((f) => (
                    <li key={f}>{f}</li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
